const PanelContent = {
  baseStyle: {
    w: "100%",
    maxW: "100%",
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
